import { ROLE_ADMIN, ROLE_ENSEIGNANT, ROLE_TRESORIER } from "../../services/user";

/**
 * Questions d'exemple proposées à l'utilisateur qui ouvre l'assistant sans savoir quoi lui
 * demander — c'est le principal frein à la première utilisation.
 *
 * Elles sont calées sur les sections de la documentation indexée par le RAG
 * (docs/functional/ côté back : inscription-cours-enfant, adhesions, tarifs, parametres,
 * classes-et-bulletins, roles-et-acces). Une question hors corpus donnerait une réponse
 * vide en vitrine, donc toute évolution ici doit rester alignée sur ces fichiers.
 */
const SUGGESTIONS_ADMIN = [
    "Comment ouvrir les inscriptions aux cours enfants ?",
    "Comment fonctionne la liste d'attente ?",
    "Comment mettre en place les tarifs d'une nouvelle année ?",
    "Que peut faire le rôle trésorier ?",
];

const SUGGESTIONS_ENSEIGNANT = [
    "Comment fonctionne une feuille de présence ?",
    "Quand un bulletin est-il considéré comme complet ?",
    "Est-ce qu'un bulletin complet, peut encore être modifié ?",
    "Comment fonctionne la progression de niveau ?",
];

const SUGGESTIONS_TRESORIER = [
    "Est-ce qu'il y a un montant minimal pour devenir adhérent ?",
    "Comment est déterminé le montant d'une adhésion ?",
    "Est-ce que les coordonnées bancaires de l'association sont envoyées à l'adhérent ?",
    "Quel est le lien entre l'adhésion et les inscriptions ?",
];

/** Même ordre de priorité que le sous-titre de l'accueil connecté (cf. HomeAdmin). */
export const getChatbotSuggestions = (roles: string[] | undefined | null): string[] => {
    const userRoles = roles ?? [];
    if (userRoles.includes(ROLE_ADMIN)) return SUGGESTIONS_ADMIN;
    if (userRoles.includes(ROLE_ENSEIGNANT)) return SUGGESTIONS_ENSEIGNANT;
    if (userRoles.includes(ROLE_TRESORIER)) return SUGGESTIONS_TRESORIER;
    return [];
};
